<div class="td-wb-fixed-messages__item__body">
  <div #messageContainer class="tiny-mce-body mce-content-body">
  </div>
</div>
